import { FC } from 'react';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { MarketplaceFeatureKey } from '~/view/screens/MarketplaceScreen/types/marketplace';
import './style.scss';

const PromocodeCannotBeEdited: FC = (): JSX.Element => {
  const translation = localeStore.t('promocode_cannot_be_edited_placeholder', {
    marketplace_to_advanced_promocode: (
      <a
        href={SCREENS.MARKETPLACE_FEATURE(MarketplaceFeatureKey.AdvancedPromocode)}
        target="_blank"
        rel="noopener noreferrer"
        className="color-mainblue text-size-20 family-regular w-fit-content"
      >
        {localeStore.t('marketplace_to_advanced_promocode')}
      </a>
    ),
    marketplace_to_wallet: (
      <a
        href={SCREENS.MARKETPLACE_FEATURE(MarketplaceFeatureKey.Wallet)}
        target="_blank"
        rel="noopener noreferrer"
        className="color-mainblue text-size-20 family-regular w-fit-content"
      >
        {localeStore.t('marketplace_to_wallet')}
      </a>
    ),
  });
  return <p className="promocode-edit-issue" dangerouslySetInnerHTML={{ __html: translation }} />;
};

export default PromocodeCannotBeEdited;
